
export const setEventAdd = (state, data) => {
  state.events.add = data
}

export const setTitlePage = (state, data) => {
  state.titlePage = data
}
